import { MaterialIcon } from '@components';
import { Stack, LinearProgress, Box, Tooltip, styled, linearProgressClasses } from '@mui/material';
import useProgressColor from '@StandingAccess/hooks/use-progress-color';

export default function AssessmentReportItemRemediation({
  inAccessFlow,
  revoked,
  total = 1,
}: {
  total: number;
  inAccessFlow?: number;
  revoked?: number;
}) {
  return (
    <Stack direction="column">
      {inAccessFlow !== undefined && (
        <AssessmentReportItemRemediationItem
          icon="lock"
          value={inAccessFlow}
          maxValue={total}
          tooltip="assignments in access flow"
        />
      )}
      {revoked !== undefined && (
        <AssessmentReportItemRemediationItem
          icon="link_off"
          value={revoked}
          maxValue={total}
          tooltip="assignments revoked"
        />
      )}
    </Stack>
  );
}

const RemediationProgress = styled(LinearProgress)<{ line?: string }>(({ theme, line }) => ({
  height: 4,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.background.hover,
  },
  [`& .${linearProgressClasses.bar}`]: {
    backgroundColor: line,
  },
}));

function AssessmentReportItemRemediationItem({
  icon,
  value,
  maxValue,
  tooltip,
}: {
  icon: string;
  value: number;
  maxValue: number;
  tooltip: string;
}) {
  const getColorFromValue = useProgressColor();
  const calculatedValue = Math.round((value / maxValue) * 100);

  return (
    <Tooltip title={`${value}/${maxValue} ${tooltip}`} placement="left" arrow>
      <Stack direction="row" alignItems="center" spacing={1}>
        <MaterialIcon symbol={icon} size="small" />
        <Box sx={{ width: '100%' }}>
          <RemediationProgress
            variant="determinate"
            color="primary"
            value={calculatedValue}
            line={getColorFromValue(calculatedValue)}
          />
        </Box>
      </Stack>
    </Tooltip>
  );
}
